import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78a0ac97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col pt-5 pb-5 overflow-y-auto h-screen bg-dark-blue" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "flex-shrink-0 h-24 w-auto mx-auto cursor-pointer",
  src: "/radisol.svg",
  alt: "Radisol"
}, null, -1))
const _hoisted_3 = { class: "mt-5 flex-grow flex flex-col" }
const _hoisted_4 = {
  class: "flex-1 pl-4",
  "aria-label": "Sidebar"
}
const _hoisted_5 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_6 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_7 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 h-8 w-6 -top-8",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_8 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8",
  style: {"border-radius":"0px 48px 0px 0px","width":"1.5rem"}
}
const _hoisted_9 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_10 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_11 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_12 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_13 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_14 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_15 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_16 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_17 = { class: "space-y-1" }
const _hoisted_18 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_19 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_20 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_21 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_22 = {
  key: 4,
  class: "shape1 bg-light-blue"
}
const _hoisted_23 = {
  key: 5,
  class: "shape2 bg-light-blue"
}
const _hoisted_24 = {
  key: 6,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_25 = {
  key: 7,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
  fill: "currentColor"
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "space-y-1" }
const _hoisted_29 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_30 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_31 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_32 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_33 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_34 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_35 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_36 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_37 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_38 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_39 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_40 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_41 = {
  key: 2,
  class: "space-y-1 pb-1"
}
const _hoisted_42 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_43 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_44 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_45 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
  fill: "currentColor"
}, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "space-y-1" }
const _hoisted_49 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_50 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_51 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_52 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_53 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_54 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_55 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_56 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_57 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_58 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_59 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_60 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_61 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_62 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_63 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_64 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_65 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_66 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_67 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_68 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_69 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_70 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_71 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 -top-8 h-8 w-6",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_72 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_73 = {
  key: 0,
  class: "shape1 bg-light-blue"
}
const _hoisted_74 = {
  key: 1,
  class: "shape2 bg-light-blue"
}
const _hoisted_75 = {
  key: 2,
  class: "bg-dark-blue absolute right-0 h-8 w-6 -top-8",
  style: {"border-radius":"0px 0px 48px 0px"}
}
const _hoisted_76 = {
  key: 3,
  class: "bg-dark-blue absolute right-0 -bottom-8 h-8 w-6",
  style: {"border-radius":"0px 48px 0px 0px"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col py-2 mx-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://kotkas.envir.ee",
    target: "_blank",
    class: "inline-flex px-5 py-2 text-sm font-normal group"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      role: "img",
      x: "",
      class: "-ml-1 mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-200 transition ease-in-out duration-500",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 235.512 235.512"
    }, [
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("path", {
          fill: "currentColor",
          stroke: "currentColor",
          "stroke-width": "3",
          "stroke-linejoin": "round",
          d: "M233.696,131.172l-38.391-17.801c-0.729-0.307-1.567-0.383-2.316-0.104l-14.619,5.085L159.059,68.56\r\n                    c-0.385-0.966-1.207-1.671-2.225-1.896L14.687,35.002c-1.31-0.247-2.645,0.291-3.338,1.445c-0.681,1.146-0.555,2.606,0.323,3.618\r\n                    l29.637,34.266L3.484,69.55c-1.262-0.165-2.542,0.495-3.14,1.655c-0.595,1.146-0.407,2.561,0.471,3.526l114.781,124.839\r\n                    c0.613,0.646,1.453,0.998,2.292,0.998c0.683,0,1.364-0.217,1.939-0.674l68.685-54.938l44.446-7.914\r\n                    c1.343-0.245,2.365-1.319,2.533-2.666C235.645,133.036,234.915,131.753,233.696,131.172z M49.455,74.291L22.473,43.113\r\n                    L153.86,72.367l18.635,48.025l-11.897,4.12l-18.522-36.095c-0.465-0.898-1.347-1.525-2.377-1.651L49.834,75.407\r\n                    C49.708,75.04,49.738,74.613,49.455,74.291z M186.609,139.006c-0.497,0.093-0.981,0.309-1.387,0.629l-27.783,22.218l-7.357-7.29\r\n                    c-1.198-1.218-3.174-1.206-4.396,0.017c-1.202,1.202-1.187,3.166,0.024,4.376l6.845,6.784l-34.382,27.516L82.869,154.84\r\n                    l56.124-12.392c1.142-0.261,2.04-1.126,2.341-2.252c0.288-1.142-0.076-2.332-0.958-3.105l-13.309-11.686\r\n                    c-1.291-1.15-3.246-1.026-4.391,0.276c-1.132,1.29-0.998,3.238,0.291,4.388l8.704,7.65l-53.664,11.866L53.2,122.6l56.298-6.853\r\n                    c1.16-0.145,2.142-0.922,2.541-2.016c0.403-1.116,0.143-2.331-0.651-3.178L99.268,97.648c-1.178-1.258-3.132-1.305-4.382-0.15\r\n                    c-1.246,1.154-1.31,3.132-0.148,4.382l7.937,8.443l-54.637,6.659l-36.96-40.199L137.27,92.741l19.02,37.021\r\n                    c0.689,1.379,2.332,2.056,3.764,1.503l33.758-11.714l28.316,13.116L186.609,139.006z"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "font-light text-gray-200 group-hover:translate-x-2 transform transition ease-in-out duration-500" }, "KOTKAS keskkond")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:tugi@radisol.ee",
    class: "inline-flex px-5 py-2 text-sm font-normal group"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      "aria-hidden": "true",
      focusable: "false",
      class: "-ml-1 mr-4 h-5 w-5 text-gray-300 group-hover:text-gray-200 transition ease-in-out duration-500",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        fill: "currentColor",
        "stroke-width": "1",
        d: "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "font-light text-gray-200 group-hover:translate-x-2 transform transition ease-in-out duration-500" }, "tugi@radisol.ee")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "tel:+3725533611",
    class: "inline-flex px-5 py-2 text-sm font-normal group"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      "aria-hidden": "true",
      focusable: "false",
      class: "-ml-1 mr-4 h-5 w-5 text-gray-300 group-hover:text-gray-200 transition-all ease-in-out duration-500",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        fill: "currentColor",
        d: "M493.09 351.3L384.7 304.8a31.36 31.36 0 0 0-36.5 8.9l-44.1 53.9A350 350 0 0 1 144.5 208l53.9-44.1a31.35 31.35 0 0 0 8.9-36.49l-46.5-108.5A31.33 31.33 0 0 0 125 .81L24.2 24.11A31.05 31.05 0 0 0 0 54.51C0 307.8 205.3 512 457.49 512A31.23 31.23 0 0 0 488 487.7L511.19 387a31.21 31.21 0 0 0-18.1-35.7zM456.89 480C222.4 479.7 32.3 289.7 32.1 55.21l99.6-23 46 107.39-72.8 59.5C153.3 302.3 209.4 358.6 313 407.2l59.5-72.8 107.39 46z"
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "font-light text-gray-200 transform group-hover:translate-x-2 transition ease-in-out duration-500" }, "+372 553 3611")
  ])
], -1))
const _hoisted_78 = { class: "flex-shrink-0 flex border-t border-gray-400 mx-4 py-4" }
const _hoisted_79 = { class: "w-full flex items-center justify-between" }
const _hoisted_80 = { class: "flex items-center group" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "-ml-1 mr-4 h-6 w-6 text-gray-200 flex-shrink-0",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1",
    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
  })
], -1))
const _hoisted_82 = { class: "whitespace-nowrap text-sm font-normal text-gray-200 transition duration-500 ease-in-out group-hover:text-green-300 group-hover:translate-x-1 transform" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 ml-1.5 text-gray-200 group-hover:text-green-300 transition duration-500 ease-in-out",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1",
    d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1",
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  })
], -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hover:bg-white hover:bg-opacity-10 h-8 w-8 rounded-md flex items-center justify-center transition duration-500 ease-in-out" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6 flex-shrink-0 text-green-300 transition duration-500 ease-in-out",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1",
      d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    })
  ])
], -1))
const _hoisted_85 = [
  _hoisted_84
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_SidebarItemSingle = _resolveComponent("SidebarItemSingle")!
  const _component_UsersIcon = _resolveComponent("UsersIcon")!
  const _component_IdentificationIcon = _resolveComponent("IdentificationIcon")!
  const _component_DocumentTextIcon = _resolveComponent("DocumentTextIcon")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_ContactIcon = _resolveComponent("ContactIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/dashboard",
      class: "flex-shrink-0 flex items-center px-4"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("nav", _hoisted_4, [
        _createVNode(_component_SidebarItemSingle, {
          class: "relative group",
          route: _ctx.RouteName.DASHBOARD_HOME
        }, {
          default: _withCtx(({ active }) => [
            active
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _createCommentVNode("", true),
            active
              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
              : _createCommentVNode("", true),
            active
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true),
            active
              ? (_openBlock(), _createElementBlock("div", _hoisted_8))
              : _createCommentVNode("", true),
            _createVNode(_component_HomeIcon, { active: active }, null, 8, ["active"]),
            _createElementVNode("div", {
              class: _normalizeClass(
              active
                ? ''
                : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
            )
            }, " Pealeht ", 2)
          ]),
          _: 1
        }, 8, ["route"]),
        (_ctx.userState.superAdmin)
          ? (_openBlock(), _createBlock(_component_SidebarItemSingle, {
              key: 0,
              class: "relative group",
              route: _ctx.RouteName.ADMINISTRATORS
            }, {
              default: _withCtx(({ active }) => [
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                  : _createCommentVNode("", true),
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                  : _createCommentVNode("", true),
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                  : _createCommentVNode("", true),
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                  : _createCommentVNode("", true),
                _createVNode(_component_UsersIcon, { active: active }, null, 8, ["active"]),
                _createElementVNode("div", {
                  class: _normalizeClass(
              active
                ? ''
                : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
            )
                }, " Administraatorid ", 2)
              ]),
              _: 1
            }, 8, ["route"]))
          : _createCommentVNode("", true),
        (_ctx.userState.admin)
          ? (_openBlock(), _createBlock(_component_SidebarItemSingle, {
              key: 1,
              class: "relative group",
              route: _ctx.RouteName.MANAGERS
            }, {
              default: _withCtx(({ active }) => [
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                  : _createCommentVNode("", true),
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                  : _createCommentVNode("", true),
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                  : _createCommentVNode("", true),
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                  : _createCommentVNode("", true),
                _createVNode(_component_IdentificationIcon, { active: active }, null, 8, ["active"]),
                _createElementVNode("div", {
                  class: _normalizeClass(
              active
                ? ''
                : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
            )
                }, " Haldajad ", 2)
              ]),
              _: 1
            }, 8, ["route"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_SidebarItemSingle, {
            class: "relative group",
            route: _ctx.RouteName.DOCUMENTATION_HOME
          }, {
            default: _withCtx(({ active }) => [
              active
                ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                : _createCommentVNode("", true),
              active
                ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                : _createCommentVNode("", true),
              active
                ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                : _createCommentVNode("", true),
              active
                ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                : _createCommentVNode("", true),
              active
                ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                : _createCommentVNode("", true),
              active
                ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                : _createCommentVNode("", true),
              active
                ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                : _createCommentVNode("", true),
              active
                ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                : _createCommentVNode("", true),
              _createVNode(_component_DocumentTextIcon, { active: active }, null, 8, ["active"]),
              _createElementVNode("div", {
                class: _normalizeClass(
                active
                  ? ''
                  : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
              )
              }, " Dokumentatsioon ", 2),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass([active ? 'rotate-90' : '', "z-50 ml-auto mr-2 h-5 w-5 transform transition ease-in-out duration-500"]),
                viewBox: "0 0 20 20",
                "aria-hidden": "true"
              }, _hoisted_27, 2))
            ]),
            _: 1
          }, 8, ["route"]),
          _withDirectives(_createElementVNode("div", _hoisted_28, [
            (_ctx.userState.admin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_SidebarItemSingle, {
                    class: "relative group",
                    route: _ctx.RouteName.DOCUMENTATION_INSTALL
                  }, {
                    default: _withCtx(({ active }) => [
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                        : _createCommentVNode("", true),
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                        : _createCommentVNode("", true),
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31))
                        : _createCommentVNode("", true),
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["pl-9", 
                  active
                    ? ''
                    : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
                ])
                      }, " Installeerimine ", 2)
                    ]),
                    _: 1
                  }, 8, ["route"]),
                  _createVNode(_component_SidebarItemSingle, {
                    class: "relative group",
                    route: _ctx.RouteName.DOCUMENTATION_UNINSTALL
                  }, {
                    default: _withCtx(({ active }) => [
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33))
                        : _createCommentVNode("", true),
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                        : _createCommentVNode("", true),
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                        : _createCommentVNode("", true),
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["pl-9", 
                  active
                    ? ''
                    : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
                ])
                      }, " Deinstalleerimine ", 2)
                    ]),
                    _: 1
                  }, 8, ["route"])
                ], 64))
              : (_ctx.userState.manager)
                ? (_openBlock(), _createBlock(_component_SidebarItemSingle, {
                    key: 1,
                    class: "relative group",
                    route: _ctx.RouteName.DOCUMENTATION_USER_MANUAL
                  }, {
                    default: _withCtx(({ active }) => [
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37))
                        : _createCommentVNode("", true),
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                        : _createCommentVNode("", true),
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39))
                        : _createCommentVNode("", true),
                      active
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["pl-9", 
                  active
                    ? ''
                    : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
                ])
                      }, " Kasutusjuhend ", 2)
                    ]),
                    _: 1
                  }, 8, ["route"]))
                : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _ctx.isDocumentationSubmenuOpen]
          ])
        ]),
        (_ctx.userState.manager)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createVNode(_component_SidebarItemSingle, {
                class: "relative group",
                route: _ctx.RouteName.CLINICS_HOME
              }, {
                default: _withCtx(({ active }) => [
                  active
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42))
                    : _createCommentVNode("", true),
                  active
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43))
                    : _createCommentVNode("", true),
                  active
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44))
                    : _createCommentVNode("", true),
                  active
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45))
                    : _createCommentVNode("", true),
                  _createVNode(_component_CalendarIcon, { active: active }, null, 8, ["active"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(
                active
                  ? ''
                  : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
              )
                  }, " Kliinikud ", 2),
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass([active ? 'rotate-90' : '', "z-50 ml-auto mr-2 h-5 w-5 transform transition ease-in-out duration-500"]),
                    viewBox: "0 0 20 20",
                    "aria-hidden": "true"
                  }, _hoisted_47, 2))
                ]),
                _: 1
              }, 8, ["route"]),
              _withDirectives(_createElementVNode("div", _hoisted_48, [
                _createVNode(_component_SidebarItemSingle, {
                  class: "relative group",
                  route: _ctx.RouteName.CLINICS_WORKERS
                }, {
                  default: _withCtx(({ active }) => [
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["pl-9", 
                  active
                    ? ''
                    : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
                ])
                    }, " Töötajad ", 2)
                  ]),
                  _: 1
                }, 8, ["route"]),
                _createVNode(_component_SidebarItemSingle, {
                  route: _ctx.RouteName.CLINICS_CABINETS
                }, {
                  default: _withCtx(({ active }) => [
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["pl-9", 
                  active
                    ? ''
                    : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
                ])
                    }, " Kabinetid ", 2)
                  ]),
                  _: 1
                }, 8, ["route"]),
                _createVNode(_component_SidebarItemSingle, {
                  route: _ctx.RouteName.CLINICS_X_RAY_EQUIPMENTS
                }, {
                  default: _withCtx(({ active }) => [
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["pl-9", 
                  active
                    ? ''
                    : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
                ])
                    }, " Röntgenseadmed ", 2)
                  ]),
                  _: 1
                }, 8, ["route"]),
                (_ctx.userState.admin)
                  ? (_openBlock(), _createBlock(_component_SidebarItemSingle, {
                      key: 0,
                      route: _ctx.RouteName.CLINICS_X_RAY_IMAGES
                    }, {
                      default: _withCtx(({ active }) => [
                        active
                          ? (_openBlock(), _createElementBlock("div", _hoisted_61))
                          : _createCommentVNode("", true),
                        active
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62))
                          : _createCommentVNode("", true),
                        active
                          ? (_openBlock(), _createElementBlock("div", _hoisted_63))
                          : _createCommentVNode("", true),
                        active
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["pl-9", 
                  active
                    ? ''
                    : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
                ])
                        }, " Ülesvõtted ", 2)
                      ]),
                      _: 1
                    }, 8, ["route"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_SidebarItemSingle, {
                  route: _ctx.RouteName.CLINICS_REPORTS
                }, {
                  default: _withCtx(({ active }) => [
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67))
                      : _createCommentVNode("", true),
                    active
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["pl-9", 
                  active
                    ? ''
                    : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
                ])
                    }, " Raportid ", 2)
                  ]),
                  _: 1
                }, 8, ["route"]),
                (_ctx.userState.admin)
                  ? (_openBlock(), _createBlock(_component_SidebarItemSingle, {
                      key: 1,
                      route: _ctx.RouteName.CLINICS_SETTINGS
                    }, {
                      default: _withCtx(({ active }) => [
                        active
                          ? (_openBlock(), _createElementBlock("div", _hoisted_69))
                          : _createCommentVNode("", true),
                        active
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                          : _createCommentVNode("", true),
                        active
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71))
                          : _createCommentVNode("", true),
                        active
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["pl-9", 
                  active
                    ? ''
                    : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
                ])
                        }, " Seaded ", 2)
                      ]),
                      _: 1
                    }, 8, ["route"]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, _ctx.isClinicsSubmenuOpen]
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.userState.admin)
          ? (_openBlock(), _createBlock(_component_SidebarItemSingle, {
              key: 3,
              class: "relative group",
              route: _ctx.RouteName.CONTACT
            }, {
              default: _withCtx(({ active }) => [
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73))
                  : _createCommentVNode("", true),
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74))
                  : _createCommentVNode("", true),
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75))
                  : _createCommentVNode("", true),
                active
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76))
                  : _createCommentVNode("", true),
                _createVNode(_component_ContactIcon, { active: active }, null, 8, ["active"]),
                _createElementVNode("div", {
                  class: _normalizeClass(
              active
                ? ''
                : 'transform transition duration-500 ease-in-out group-hover:translate-x-2'
            )
                }, " Kontakt ", 2)
              ]),
              _: 1
            }, 8, ["route"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_77,
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", {
          class: "flex-shrink-0 pl-5 w-full block cursor-pointer",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args)))
        }, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _hoisted_81,
              _createElementVNode("p", _hoisted_82, _toDisplayString(_ctx.name), 1),
              _hoisted_83
            ]),
            _createElementVNode("div", {
              class: "flex-shrink-0 group",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
            }, _hoisted_85)
          ])
        ])
      ])
    ])
  ]))
}